import React, { useEffect, useState } from 'react';
import {
  CompanyTagsDataService,
  CompanyTagsPrimaryDataService,
} from '../../common/services';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Option } from 'react-bootstrap-typeahead/types/types';
import { isArray } from 'lodash';

interface Props {
  onSelect: (name: string, selected: Option[]) => void;
  selected?: Option | Option[];
  multiple: boolean;
  id: string;
  name: string;
  required?: boolean;
  primarySecondaryOnly?: boolean;
}

/**
 * @description High level component for dealing with Briefed.in marketplace.
 * @param {Props} props
 * @return {JSX.Element}
 */
const CompanyTagSelect = (props: Props): JSX.Element => {
  const [companyTags, setCompanyTags] = useState<string[]>([]);
  const [busy, setBusy] = useState<boolean>(false);

  const getCompanyTags = async (): Promise<void> => {
    setBusy(true);

    const result = props.primarySecondaryOnly
      ? await CompanyTagsPrimaryDataService.getAll()
      : await CompanyTagsDataService.getAll();
    setCompanyTags(result.map((item) => item.id));
    setBusy(false);
  };

  // on first render
  useEffect(() => {
    getCompanyTags();
  }, []);

  const selected = !props.selected
    ? []
    : isArray(props.selected)
    ? props.selected
    : [props.selected];

  const required = props.required ?? false;

  return (
    <React.Fragment>
      <Typeahead
        id={props.id}
        multiple={props.multiple}
        allowNew={true}
        isLoading={busy}
        inputProps={{ required: required }}
        // labelKey={(option) => `${(option as CompanyTagResource).id}`}
        options={companyTags}
        onChange={(selected) => {
          props.onSelect(props.name, selected);
        }}
        selected={selected}
      />
    </React.Fragment>
  );
};

export default CompanyTagSelect;
